import { apiSoliq } from '@/services/axios'
// import { transformIntoQuery } from '@/utils/pagination'

class SoliqService {
  constructor() {
    this.$soliq = apiSoliq
  }

  getTest(value) {
    return this.$soliq.get(`https://tasnif.soliq.uz/api/cls-api/elasticsearch/search?lang=uz_cyrl&search=${value}&size=20&page=0`)
  }
}

export default new SoliqService()
